export default __webpack_public_path__ + "static/media/img_18.d2f18bcc.JPG";